<template>
	<div class="business-corps-page">
		<section class="sec-10">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.business_corps_page_v2.sec_10.title.one') }}
					<strong>
						{{ $t('new_ui.business_corps_page_v2.sec_10.title.two') }}
					</strong>
				</h2>
				<p>
					{{ $t('new_ui.business_corps_page_v2.sec_10.desc.one') }}<br />
					{{ $t('new_ui.business_corps_page_v2.sec_10.desc.two') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.business_corps_page_v2.sec_10.btn.one') }}
					</a>
					<a
						href="javascript:void(0)"
						@click="showComingSoon"
						class="btn-type-02"
					>
						{{ $t('new_ui.business_corps_page_v2.sec_10.btn.two') }}
					</a>
				</div>
				<div class="img-box">
					<img :src="img.imgBusinessCorpsSec10" alt="" />
				</div>
			</div>
		</section>
		<section class="sec-11">
			<div class="container-box">
				<div class="content-box content-01">
					<h3>
						{{ $t('new_ui.business_corps_page_v2.sec_11.one.title.one') }}<br />
						{{ $t('new_ui.business_corps_page_v2.sec_11.one.title.two') }}
					</h3>
					<p>
						{{ $t('new_ui.business_corps_page_v2.sec_11.one.desc.one') }}<br />
						{{ $t('new_ui.business_corps_page_v2.sec_11.one.desc.two') }}
					</p>
				</div>
				<div class="content-box content-02">
					<h3>
						{{ $t('new_ui.business_corps_page_v2.sec_11.two.title.one') }}<br />
						{{ $t('new_ui.business_corps_page_v2.sec_11.two.title.two') }}
					</h3>
					<p>
						{{ $t('new_ui.business_corps_page_v2.sec_11.two.desc.one') }}<br />
						{{ $t('new_ui.business_corps_page_v2.sec_11.two.desc.two') }}
					</p>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgBusinessCorpsSec10 from '@/assets/images/v2/img-business-corps-sec-10.png';

export default {
	data: () => {
		return {
			img: {
				imgBusinessCorpsSec10,
			},
		};
	},
	methods: {
		showComingSoon() {
			alert('Coming soon.');
		},
	},
};
</script>
